import React from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';

interface ClientRenderedContentProps {
  children: React.ReactNode;
  renderOnServer?: boolean;
}

// Component version of the useServerSideRendering hook.
const ClientRenderedContent = ({
  children,
  renderOnServer = false,
}: ClientRenderedContentProps): JSX.Element => {
  const hydrated = useServerSideRendering();

  return <>{renderOnServer ? children : hydrated && children}</>;
};

export default ClientRenderedContent;
